/* eslint-disable no-param-reassign, max-params */
import { api } from "jiffy-api";

const initialState = {
  productId: null,
  compositionId: null,
  catalogNumber: null,
  product: null
};

const productModule = {
  namespaced: true,

  state() {
    return { ...initialState };
  },

  getters: {
    productId: state => state.productId,
    neckLines: state => state.product?.neck_line_distances || {},
    getNeckLine: (state, getters) => (surface, label) =>
      getters.neckLines[surface]?.[label] || {
        default: 0,
        max_height: 0
      },
    compositionId: state => state.compositionId,
    catalogNumber: state => state.catalogNumber,
    currentComposition: (state, getters) =>
      state.product?.compositions?.find(({ id }) => id === getters.compositionId) || {},
    currentProduct: state => state.product
  },

  mutations: {
    setDefaultData(state, payload) {
      state.productId = payload.product_id;
      state.catalogNumber = payload.catalog_number;
      state.compositionId = payload.composition_id;
    },
    setCompositionId(state, compositionId) {
      state.compositionId = compositionId;
    }
  },

  actions: {
    async fetchProduct({ getters, state }) {
      state.product = await api.printOnDemand.getProduct({ catalog_number: getters.catalogNumber });
    }
  }
};

export default productModule;
